const petitionForm = {
	el: {
		btnShowForm: document.querySelector('.js-show-petition-form'),
		formPetition: document.querySelector('.js-form-petition'),
		resultPetition: document.querySelector('.js-result-petition'),
		header: document.querySelector('.header')
	},

	fxScrollToPetitionForm(id, jsClass = null) {
		if(window.location.pathname.includes(id)) {
			const target = jsClass !== null ? document.getElementById('peticao') : document.getElementById(id),
				headerHeight = this.el.header.classList.contains('sticky') ? this.el.header.offsetHeight : 0,
				supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style

			if (target) {
				if (supportsNativeSmoothScroll)
					window.scroll({
						behavior: 'smooth',
						top: target.offsetTop - headerHeight,
						left: 0
					})

				else
					scrollToElement.fxSmoothScrollToPolyfill(target.offsetTop - headerHeight, 1000)
			}
		}

	},

	events() {
		//show loader
		this.el.formPetition.addEventListener('submit', e => {
			formHelper.fxShowLoader(e.currentTarget)
		})

		if(this.el.btnShowForm) {
			this.el.btnShowForm.addEventListener('click', e => {
				formHelper.fxToggleDisplayStep(e.currentTarget)
			})
		}
		
		//validate form
		formValidation.fxValidations(this.el.formPetition)

		this.fxScrollToPetitionForm('peticao')
		this.fxScrollToPetitionForm('registado', '.js-form-petition')
	},

	init () {
		if(this.el.resultPetition) {
			this.fxScrollToPetitionForm('registado', '.js-result-petition')
			this.fxScrollToPetitionForm('assinar-peticao', '.js-result-petition')
		}
		if(!this.el.formPetition) return
		this.events()
	}
}

petitionForm.init()